import GroupDeviationsEmptyResult from './GroupDeviationsEmptyResult';
import GroupDeviationsEmptyResultContainer from './GroupDeviationsEmptyResult.container';

export default GroupDeviationsEmptyResultContainer(GroupDeviationsEmptyResult);
